import { Web3DViewer } from '@technology/web3d';
import { CapabilityProviderBase } from '@trimble/web3d-providers';
import { CapabilityBase } from './capability-base';

/**
 * Capability for a single viewer.
 */
export abstract class SingleCapabilityBase extends CapabilityBase {
  constructor(
    protected viewer: Web3DViewer,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    provider?: CapabilityProviderBase<any>
  ) {
    super(provider);
  }
}
